const { IsPCBrowser } = require('@/utils/browser')
const { getCourseDetailPcUrl, getAdvancedPcUrl } = require('@/config/deviceURL')

module.exports = {
  created() {
    if (IsPCBrowser()) {
      this.toPC()
    }
  },
  methods: {
    // 跳转PC界面
    toPC() {
      let pcURL = ''
      const { province, no } = this.$route.query
      const brandKey = this.getCurrentBrand.brandKey
      if (this.unitName === 'course') {
        pcURL = getCourseDetailPcUrl(brandKey, this.$route.query)
      }
      if (this.unitName === 'Advanced') {
        pcURL = getAdvancedPcUrl(brandKey, this.$route.query)
      }

      console.log(this.unitName)
      if (pcURL) {
        window.location.replace(pcURL)
      }
    },
  },
}
